const iqID = require('../../identifiers');

const parseRadioIds = _id => [`${_id}_yes`, `${_id}_no`];

module.exports = {
  questions: {
    generalInvestorRepresentationsandWarranties: [
      {
        id: 'girw-1',
        displayName:
          '1. The undersigned’s interest in the Fund will be acquired for investment, and not with a view to the sale or distribution of any part thereof, and that the undersigned has no present intention of selling, granting participation in, or otherwise distributing the same, but subject nevertheless to any requirement of law that the disposition of the undersigned’s property shall at all times be within the control of the undersigned.',
      },
      {
        id: 'girw-2',
        displayName:
          '2. The undersigned will hold its interest in the Fund for itself beneficially and does not nor will have any contract, undertaking, agreement, or arrangement with any person to sell or transfer to any third person its interest in the Fund and is not acting as nominee or trustee or otherwise on behalf of any other person.',
      },
      {
        id: 'girw-3',
        displayName:
          '3. The undersigned has such knowledge and experience in financial and business matters as to be capable of evaluating the merits and risks of an investment in the Fund.',
      },
      {
        id: 'girw-4',
        displayName:
          '4. The undersigned does not control, nor is controlled by or under common control with, any other investors in the Fund.',
      },
      {
        id: 'girw-5',
        displayName:
          '5. The undersigned would be considered, and the interest in the Fund held by the undersigned would be considered to be beneficially owned by, “one person” for purposes of Section 3(c)(1) of the United States Investment Company Act of 1940 (the “1940 Act”).',
      },
      {
        id: 'girw-6',
        displayName:
          '6. If the undersigned relies on Section 3(c)(1) or Section 3(c)(7) of the 1940 Act for its exclusion from being deemed an investment company, the undersigned hereby represents and warrants that it has obtained the consent to its treatment as a qualified purchaser from the appropriate beneficial owners of its securities in accordance with the requirements of, and only to the extent required by, Section 2(a)(51)(C) of and Rule 2a51-2 under the 1940 Act.',
      },
      {
        id: 'girw-7',
        displayName:
          '7. The undersigned hereby consents to the treatment of the Fund as a qualified purchaser, and represents and warrants that it has obtained the consent for such treatment from the appropriate beneficial owners of its securities in accordance with the requirements of, and only to the extent required by, Section 2(a)(51)(C) and Rule 2a51-2 under the 1940 Act.',
      },
      {
        id: 'girw-8',
        displayName:
          '8. If the undersigned is a partnership, grantor trust, S corporation, or other flow-through entity for federal income tax purposes, the undersigned represents and warrants that it has not been formed or utilized for the purpose of permitting the Fund to satisfy the 100-partner limitation set forth in U.S. Treasury Regulation Section 1.77041(h)(1)(ii).',
      },
      {
        id: 'girw-9',
        displayName:
          '9. If the undersigned is a resident of, or domiciled in, any jurisdiction within the European Economic Area or Switzerland, the undersigned represents and warrants that (a) it actively solicited the Fund’s manager in connection with a prospective investment in the Fund, (b) it approached the Fund’s manager on its own initiative, (c) its interest in the Fund and the Fund’s manager did not come about as a result of any direct or indirect marketing, offering or placement efforts by or on behalf of the Fund or the Fund’s manager and (d) neither the European Union (EU) Directive on Alternative Investment Fund Managers nor any similar national legislation applies to the undersigned’s interest in the Fund.',
      },
      {
        id: 'girw-10',
        displayName:
          '10. The undersigned acknowledges that neither the General Partner nor its affiliates provide, or intend to provide, advice to the Fund with respect to investment strategies that are plans or programs for the investment of the proceeds of municipal securities or the recommendation of and brokerage of municipal escrow investments. The undersigned represents and agrees that none of the undersigned’s contributions to the Fund will consist of “proceeds of municipal securities,” within the meaning of Rule 15Ba1-1(m)(1) under the United States Securities Exchange Act of 1934.',
      },
      {
        id: 'girw-11',
        displayName:
          '11. The undersigned represents that it is not investing in the Fund as a result of any form of general solicitation or general advertising, including without limitation (a) any advertisement, article, notice or other communications published in any newspaper, magazine or other media (including any publications via the Internet and any social media platforms) or broadcast over television, radio or other media or (b) any seminar or meeting whose attendees were invited by any general solicitation or general advertising.',
      },
      {
        id: 'girw-12',
        displayName:
          '12. If the undersigned is an entity, the undersigned represents and warrants that (a) its shareholders, partners or other holders of equity or beneficial interests are not able to decide individually whether to participate in the undersigned’s investment in the Fund, (b) the undersigned is not a participant-directed defined contribution plan, (c) the amount of the undersigned’s capital commitment in the Fund, does not exceed 40% of the undersigned’s total assets and (d) the undersigned was not created solely for the purpose of making this investment in the Fund.',
      },
      {
        id: 'girw-13',
        displayName:
          '13. If the undersigned is a regulated institution that is subject to legal or regulatory restrictions or limitations on the amount or nature of its investments (e.g., a bank or insurance company), the undersigned hereby represents and warrants that its capital contribution to the Fund will not contravene such laws and regulations.',
      },
      {
        id: 'girw-14',
        displayName:
          '14. If the undersigned is either a Bank Holding Company or a Financial Holding Company Partner (see Part 2, Section H, Question 4), the undersigned hereby (a) represents and warrants that its investment in the Fund does not violate Section 13 of the United States Bank Holding Company Act of 1956, as amended (the “Volcker Rule”) and (b) if admitted to the Fund, covenants that it shall immediately provide the General Partner with written notice if the holding of an interest in the Fund would subsequently cause the undersigned to violate the Volcker Rule.',
      },
      {
        id: 'girw-15',
        displayName:
          '15. The undersigned acknowledges that representatives of the Fund have made available to the undersigned, during the course of this transaction and prior to the purchase of the interest in the Fund, the opportunity to ask questions of and receive answers from them concerning the terms and conditions of the offering of the Interests described in the Fund Agreement and this Investor Questionnaire, and to obtain any additional information necessary to verify the information contained in the Fund Agreement and this Investor Questionnaire or otherwise relative to the proposed activities of the Fund or to otherwise evaluate the merits and risks of an investment in the interest in the Fund.',
      },
    ],
    identificationofInvestorStatus: [
      {
        id: iqID.id_investor_status_1,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_1),
        name: 'E_1_quest',
        displayName:
          '1. Natural Person: Is the undersigned a natural person? (For clarity, the Investor is a “natural person” if the Investor is an individual investing through a personal account, and not through a trust, LLC, partnership or other entity. If the investment is being made through an entity, the Investor is not a natural person.)',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_2,
        tooltip:
          'For purposes of such Rule 902(k), "U.S. person" means: <br /><br /><div class="tooltip-list-item">i. Any natural person resident in the United States;</div><div class="tooltip-list-item">ii. Any partnership or corporation organized or incorporated under the laws of the United States;</div><div class="tooltip-list-item">iii. Any estate of which any executor or administrator is a U.S. person;</div><div class="tooltip-list-item">iv. Any trust of which any trustee is a U.S. person;</div><div class="tooltip-list-item">v. Any agency or branch of a foreign entity located in the United States;</div><div class="tooltip-list-item">vi. Any non-discretionary account or similar account (other than an estate or trust) held by a dealer or other fiduciary for the benefit or account of a U.S. person;</div><div class="tooltip-list-item">vii. Any discretionary account or similar account (other than an estate or trust) held by a dealer or other fiduciary organized, incorporated, or (if an individual) resident in the United States; and</div><div class="tooltip-list-item">viii. Any partnership or corporation if:</div><div class="tooltip-list-item-option">A. Organized or incorporated under the laws of any foreign jurisdiction; and</div><div class="tooltip-list-item-option">B. Formed by a U.S. person principally for the purpose of investing in securities not registered under the Act, unless it is organized or incorporated, and owned, by accredited investors (as defined in Rule 501(a)) who are not natural persons, estates or trusts.</div>The following are not "U.S. persons":<div class="tooltip-list-item">i. Any discretionary account or similar account (other than an estate or trust) held for the benefit or account of a non-U.S. person by a dealer or other professional fiduciary organized, incorporated, or (if an individual) resident in the United States;</div><div class="tooltip-list-item">ii. Any estate of which any professional fiduciary acting as executor or administrator is a U.S. person if:</div><div class="tooltip-list-item-option">A. An executor or administrator of the estate who is not a U.S. person has sole or shared investment discretion with respect to the assets of the estate; and</div><div class="tooltip-list-item-option">B. The estate is governed by foreign law;</div><div class="tooltip-list-item">iii. Any trust of which any professional fiduciary acting as trustee is a U.S. person, if a trustee who is not a U.S. person has sole or shared investment discretion with respect to the trust assets, and no beneficiary of the trust (and no settlor if the trust is revocable) is a U.S. person;</div><div class="tooltip-list-item">iv. An employee benefit plan established and administered in accordance with the law of a country other than the United States and customary practices and documentation of such country;</div><div class="tooltip-list-item">v. Any agency or branch of a U.S. person located outside the United States if:</div><div class="tooltip-list-item-option">A. The agency or branch operates for valid business reasons; and</div><div class="tooltip-list-item-option">B. The agency or branch is engaged in the business of insurance or banking and is subject to substantive insurance or banking regulation, respectively, in the jurisdiction where located; and</div><div class="tooltip-list-item">vi. The International Monetary Fund, the International Bank for Reconstruction and Development, the Inter-American Development Bank, the Asian Development Bank, the African Development Bank, the United Nations, and their agencies, affiliates and pension plans, and any other similar international organizations, their agencies, affiliates and pension plans.</div>',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_2),
        name: 'E_2_quest',
        displayName:
          '2. U.S. Person (U.S. Securities Act): Is the undersigned a “U.S. Person” as defined in Rule 902(k) promulgated under the United States Securities Act of 1933, as amended (the “Securities Act”)?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_3,
        tooltip:
          '<span>The term “United States person” means—<br /><br /><div class="tooltip-list-item">(A) a citizen or resident of the United States,</div><div class="tooltip-list-item">(B) a domestic partnership,</div><div class="tooltip-list-item">(C) a domestic corporation,</div><div class="tooltip-list-item">(D) any estate (other than a foreign estate, within the meaning of Section 7701(a)(31) of the Code), and</div><div class="tooltip-list-item">(E) any trust if—</div><div class="tooltip-list-item-option">(i) a court within the United States is able to exercise primary supervision over the administration of the trust, and</div><div class="tooltip-list-item-option"> (ii) one or more United States persons have the authority to control all substantial decisions of the trust.</div></span>',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_3),
        name: 'E_3_quest',
        displayName:
          '3. U.S. Person (U.S. Internal Revenue Code): Is the undersigned a “United States person” as defined in section 7701(a)(30) of the Internal Revenue Code?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_4,
        tooltip:
          'An affiliate of a FINRA member is any person that controls, is controlled by, or is under common control with such FINRA member. Without limiting the foregoing in any way, a person will be presumed to control a FINRA member if such person owns 10% or more of the economic interest or voting power in such FINRA member. A FINRA member will be presumed to control a company if the member has 10% or more of the economic interest or voting power in such company. A company and a FINRA member will be presumed to be under common control if a single person owns 10% or more of the economic interest or voting power in both such other company and such FINRA member. A company and a FINRA member will also be presumed to be under common control if another person has the power to direct or cause the direction of the management or policies of both the FINRA member and such other company. (FINRA Rule 5121(f)(6))\n4 A person associated with a FINRA member means a natural person which is registered or has applied for registration under the FINRA rules and every sole proprietor, partner, officer, director or branch manager of any FINRA member, or any natural person occupying a similar status or performing similar functions, or any natural person engaged in the investment banking or securities business who is directly or indirectly controlling or controlled by a FINRA member, whether or not such person is registered or exempt from registration with FINRA pursuant to its Bylaws.\n5 As used herein, Portfolio Company Information shall mean any financial information, valuation or other confidential information (other than the name of the portfolio company and the cost basis of the investment) relating to the Fund’s current, past or prospective portfolio companies.',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_4),
        name: 'E_4_quest',
        displayName:
          '4. FINRA Affiliation: Is the undersigned (a) a member of the Financial Industry Regulatory Authority (“FINRA,” which was formerly known as the National Association of Securities Dealers or NASD), (b) a person affiliated with a FINRA member, (c) a person associated with a FINRA member or (d) a person directly or indirectly engaged in the securities business as a broker, dealer or underwriter, whether as an employee, director, partner, registered representative or otherwise?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'E_5_quest',
        displayName: '5. FOIA Partner / Public Disclosure Laws:',

        size: 'large',
        type: 'title',
      },
      {
        id: iqID.id_investor_status_5_a,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_a),
        name: 'E_5_a_quest',
        displayName:
          '(a). Is the undersigned a person that is directly or indirectly subject to either section 552(a) of Title 5, United States Code (commonly known as the “Freedom of Information Act”) or any similar federal, state, county or municipal public disclosure law, whether foreign or domestic?:',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5_b,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_b),
        name: 'E_5_b_quest',
        displayName:
          '(b). Is the undersigned a person that is subject, by regulation, contract or otherwise, to disclose Fund information due to regulatory or trading exchange or other market requirements where interests in such Person are registered, regulated, sold or traded, whether foreign or domestic?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5_c,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_c),
        name: 'E_5_c_quest',
        displayName:
          '(c). Is the undersigned a person that is required to or will likely be required to disclose Fund information to a governmental body, agency or committee (including, without limitation, any disclosures required in accordance with the Ethics in Government Act of 1978, as amended, and any rules and regulations of any executive, legislative or judiciary organization), whether foreign or domestic, by virtue of such person’s (or any of its affiliate’s) current or proposed involvement in government office?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5_d,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_d),
        name: 'E_5_d_quest',
        displayName:
          '(d). Is the undersigned a person that is an agent, nominee, fiduciary, custodian or trustee for any person described in the preceding questions 5(a)-(c) where Fund information provided or disclosed to the undersigned, as a limited partner of the Fund, by or on behalf of the Fund, its General Partner or its management company is provided or could at any time become available to such person described by the preceding questions 5(a)-(c)?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5_e,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_e),
        name: 'E_5_e_quest',
        displayName:
          '(e). Is the undersigned a person that is an investment fund or other entity that has any person described in the preceding questions 5(a)-(d) as a partner, member or other beneficial owner where Fund information provided or disclosed to the undersigned, as a limited partner of the Fund, by or on behalf of the Fund, its General Partner or its management company is disclosed to or could at any time become available to such person described by the preceding questions 5(a)-(d)?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_5_f,
        tooltip:
          'As used herein, Portfolio Company Information shall mean any financial information, valuation or other confidential information (other than the name of the portfolio company and the cost basis of the investment) relating to the Fund’s current, past or prospective portfolio companies.',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_5_f),
        name: 'E_5_f_quest',
        displayName:
          '(f). If the answer to any of 5(a)-(e) above is “YES,” does the undersigned reasonably believe (based on the advice of counsel) that it would not be required by law to disclose any Portfolio Company Information that is provided to the undersigned by the Fund, the General Partner or any affiliate or agent thereof? (For clarity, a “No” answer indicates that the undersigned reasonably believes it could be required by law to disclose Portfolio Company Information.)',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_6,
        tooltip:
          'Rule 506(d) disqualifies persons who have been convicted of certain felonies and misdemeanors or who have been subject to certain orders, judgments or decrees.<br /><br />“Bad Actor” Disqualification: Rule 506(d) of Regulation D promulgated by the Securities and Exchange Commission states:<br /><br /><div class="tooltip-list-item">(d) “Bad Actor” disqualification.  (1) No exemption under this section shall be available for a sale of securities if the issuer; any predecessor of the issuer; any affiliated issuer; any director, executive officer, other officer participating in the offering, general partner or managing member of the issuer; any beneficial owner of 20% or more of the issuer’s outstanding voting equity securities, calculated on the basis of voting power; any promoter connected with the issuer in any capacity at the time of such sale; any investment manager of an issuer that is a pooled investment fund; any person that has been or  will  be  paid  (directly  or  indirectly)  remuneration  for  solicitation  of  purchasers  in  connection  with such sale of securities; any general partner or managing member of any such investment manager or solicitor;  or  any  director,  executive  officer  or  other  officer  participating  in  the  offering  of  any  such investment manager or solicitor or general partner or managing member of such investment manager or solicitor:</div><div class="tooltip-list-item">(i)  Has  been  convicted,  within  ten  years  before  such  sale  (or  five  years,  in  the  case  of  issuers, their predecessors and affiliated issuers), of any felony or misdemeanor:</div><div class="tooltip-list-item">(A) In connection with the purchase or sale of any security; </div><div class="tooltip-list-item">(B) Involving the making of any false filing with the Commission; or</div><div class="tooltip-list-item">(C)  Arising  out  of  the  conduct  of  the  business  of  an  underwriter,  broker,  dealer,  municipal securities dealer, investment adviser or paid solicitor of purchasers of securities;</div><div class="tooltip-list-item">(ii)  Is  subject  to  any  order,  judgment  or  decree  of  any  court  of  competent  jurisdiction,  entered within five years before such sale, that, at the time of such sale, restrains or enjoins such person from engaging or continuing to engage in any conduct or practice:</div><div class="tooltip-list-item">(A) In connection with the purchase or sale of any security;</div><div class="tooltip-list-item">(B) Involving the making of any false filing with the Commission; or</div><div class="tooltip-list-item">(C)  Arising  out  of  the  conduct  of  the  business  of  an  underwriter,  broker,  dealer,  municipal securities dealer, investment adviser or paid solicitor of purchasers of securities;</div><div class="tooltip-list-item">(iii) Is subject to a final order of a state securities commission (or an agency or officer of a state performing like functions); a state authority that supervises or examines banks, savings associations, or  credit  unions;  a  state  insurance  commission  (or  an  agency  or  officer  of  a  state  performing  like functions); an appropriate federal banking agency; the U.S. Commodity Futures Trading Commission; or the National Credit Union Administration that: </div><div class="tooltip-list-item">(A) At the time of such sale, bars the person from:</div><div class="tooltip-list-item">( 1 ) Association with an entity regulated by such commission, authority, agency, or officer;</div><div class="tooltip-list-item">( 2 ) Engaging in the business of securities, insurance or banking; or</div><div class="tooltip-list-item">( 3 ) Engaging in savings association or credit union activities; or</div><div class="tooltip-list-item">(B)  Constitutes  a  final  order  based  on  a  violation  of  any  law  or  regulation  that  prohibits fraudulent, manipulative, or deceptive conduct entered within ten years before such sale;</div><div class="tooltip-list-item">(iv) Is subject to an order of the Commission entered pursuant to section 15(b) or 15B(c) of the Securities  Exchange  Act  of  1934  (15  U.S.C.  78 o  (b)  or  78 o  -4(c))  or  section  203(e)  or  (f)  of  the Investment Advisers Act of 1940 (15 U.S.C. 80b-3(e) or (f)) that, at the time of such sale:</div><div class="tooltip-list-item">(A)  Suspends  or  revokes  such  person’s  registration  as  a  broker,  dealer,  municipal  securities dealer or investment adviser;</div><div class="tooltip-list-item">(B) Places limitations on the activities, functions or operations of such person; or</div><div class="tooltip-list-item">(C) Bars such person from being associated with any entity or from participating in the offering of any penny stock;</div><div class="tooltip-list-item">(v) Is subject to any order of the Commission entered within five years before such sale that, at the time of such sale, orders the person to cease and desist from committing or causing a violation or future violation of:</div><div class="tooltip-list-item">(A)  Any  scienter-based  anti-fraud  provision  of  the  federal  securities  laws,  including  without limitation  section  17(a)(1)  of  the  Securities  Act  of  1933  (15  U.S.C.  77q(a)(1)),  section  10(b)  of  the Securities  Exchange  Act  of  1934  (15  U.S.C.  78j(b))  and  17  CFR  240.10b-5,  section  15(c)(1)  of  the Securities  Exchange  Act  of  1934  (15  U.S.C.  78 o  (c)(1))  and  section  206(1)  of  the  Investment Advisers Act of 1940 (15 U.S.C. 80b-6(1)), or any other rule or regulation thereunder; or</div><div class="tooltip-list-item">(B) Section 5 of the Securities Act of 1933 (15 U.S.C. 77e).</div><div class="tooltip-list-item">(vi) Is suspended or expelled from membership in, or suspended or barred from association with a member of, a registered national securities exchange or a registered national or affiliated securities association  for  any  act  or  omission  to  act  constituting  conduct  inconsistent  with  just  and  equitable principles of trade</div><div class="tooltip-list-item">(vii)  Has  filed  (as  a  registrant  or  issuer),  or  was  or  was  named  as  an  underwriter  in,  any registration  statement  or  Regulation  A  offering  statement  filed  with  the  Commission  that,  within  five years  before  such  sale,  was  the  subject  of  a  refusal  order,  stop  order,  or  order  suspending  the Regulation A exemption, or is, at the time of such sale, the subject of an investigation or proceeding to determine whether a stop order or suspension order should be issued; or</div><div class="tooltip-list-item"></div><div class="tooltip-list-item">(viii)  Is  subject  to  a  United  States  Postal  Service  false  representation  order  entered  within  five years  before  such  sale,  or  is,  at  the  time  of  such  sale,  subject  to  a  temporary  restraining  order  or preliminary injunction with respect to conduct alleged by the United States Postal Service to constitute a  scheme  or  device  for  obtaining  money  or  property  through  the  mail  by  means  of  false representations.</div><div class="tooltip-list-item">(2) Paragraph (d)(1) of this section shall not apply:</div><div class="tooltip-list-item">(i)  With  respect  to  any  conviction,  order,  judgment,  decree,  suspension,  expulsion  or  bar  that occurred or was issued before September 23, 2013; </div><div class="tooltip-list-item">(ii) Upon a showing of good cause and without prejudice to any other action by the Commission, if the Commission determines that it is not necessary under the circumstances that an exemption be denied; </div><div class="tooltip-list-item">(iii) If, before the relevant sale, the court or regulatory authority that entered the relevant order, judgment or decree advises in writing (whether contained in the relevant judgment, order or decree or separately to the Commission or its staff) that disqualification under paragraph (d)(1) of this section should not arise as a consequence of such order, judgment or decree; or</div><div class="tooltip-list-item">(iv) If the issuer establishes that it did not know and, in the exercise of reasonable care, could not have known that a disqualification existed under paragraph (d)(1) of this section.</div><div class="tooltip-list-item">nstruction  to  paragraph  (d)(2)(iv).  An  issuer  will  not  be  able  to  establish  that  it  has  exercised reasonable  care  unless  it  has  made,  in  light  of  the  circumstances,  factual  inquiry  into  whether  any disqualifications  exist.  The  nature  and  scope  of  the  factual  inquiry  will  vary  based  on  the  facts  and circumstances concerning, among other things, the issuer and the other offering participants.</div><div class="tooltip-list-item">(3) For purposes of paragraph (d)(1) of this section, events relating to any affiliated issuer that occurred before the affiliation arose will be not considered disqualifying if the affiliated entity is not: </div><div class="tooltip-list-item">(i) In control of the issuer; or</div><div class="tooltip-list-item">(ii)  Under  common  control  with  the  issuer  by  a  third  party  that  was  in  control  of  the  affiliated entity at the time of such events.</div>',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_6),
        name: 'E_6_quest',
        displayName:
          '6. “Bad Actor” Disqualification: Is the undersigned subject to “Bad Actor” disqualification, as such term is used in Rule 506(d) of Regulation D promulgated by the Securities and Exchange Commission?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_investor_status_7,
        tooltip: 'Under FINRA Rule 4512(c), the term “Institutional Account” means the account of: (1) a bank, savings and loan association, insurance company or registered investment company; (2) an investment adviser registered either with the U.S. Securities and Exchange Commission under Section 203 of the Investment Advisers Act of 1940, or with a state securities commission (or any agency or office performing like functions); or (3) any other entity or person with total assets of at least $50 million as of the date hereof (whether such assets are invested for such person’s own account or under management for the account of others).',
        radioIdentifier: parseRadioIds(iqID.id_investor_status_7),
        name: 'E_7_quest',
        displayName: `7. Institutional Account Status: Does the undersigned qualify as an “Institutional Account” as defined in FINRA Rule 4512(c)?`,
        size: 'large',
        type: 'quest',
      }
    ],
    accreditedInvestorRepresentations: [
      {
        id: iqID.id_investor_representations_1,
        showHelp: true,
        helpText:
          'For purposes of calculating the net worth of a natural person, the amount of any mortgage or other indebtedness secured by such person’s primary residence must be netted against the value of such residence. If the amount of such indebtedness is less than the estimated fair market value of such residence, it need not be considered as a liability deducted from such natural person’s net worth (except that if the amount of indebtedness outstanding at the time of the sale of securities exceeds the amount outstanding 60 days before such time, other than as a result of the acquisition of the primary residence, the amount of such excess shall be included as a liability). If the amount of such indebtedness exceeds the estimated fair market value of such residence, then that excess liability must be deducted from such natural person’s net worth.',
        displayName:
          'A natural person whose individual net worth, or joint net worth with that person’s spouse, at the time of his purchase exceeds $1,000,000 (excluding the value of the primary residence of such natural person).',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_1',
      },
      {
        id: iqID.id_investor_representations_2,
        showHelp: false,
        helpText: '',
        displayName:
          'A natural person who had an individual income in excess of $200,000 in each of the two most recent years or joint income with that person’s spouse in excess of $300,000 in each of those years and has a reasonable expectation of reaching the same income level in the current year.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_2',
      },
      {
        id: iqID.id_investor_representations_3,
        showHelp: false,
        helpText: '',
        displayName:
          'A bank as defined in section 3(a)(2) of the Securities Act, or any savings and loan association or other institution as defined in section 3(a)(5)(A) of the Securities Act whether acting in its individual or fiduciary capacity; any broker or dealer registered pursuant to section 15 of the Securities Exchange Act of 1934; any insurance company as defined in section 2(13) of the Securities Act; any investment company registered under the 1940 Act or a business development company as defined in section 2(a)(48) of that Act; any Small Business Investment Company licensed by the U.S. Small Business Administration under section 301(c) or (d) of the Small Business Investment Act of 1958; any plan established and maintained by a state, its political subdivisions, or any agency or instrumentality of a state or its political subdivisions, for the benefit of its employees, if such plan has total assets in excess of $5,000,000; any employee benefit plan within the meaning of the Employee Retirement Income Security Act of 1974 if the investment decision is made by a plan fiduciary, as defined in section 3(21) of such act, which is either a bank, savings and loan association, insurance company, or registered investment adviser, or if the employee benefit plan has total assets in excess of $5,000,000 or, if a self-directed plan, with investment decisions made solely by persons that are accredited investors.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_3',
      },
      {
        id: iqID.id_investor_representations_4,
        showHelp: false,
        helpText: '',
        displayName:
          'A private business development company as defined in section 202(a)(22) of the Investment Advisers Act of 1940.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_4',
      },
      {
        id: iqID.id_investor_representations_5,
        showHelp: false,
        helpText: '',
        displayName:
          'An organization described in section 501(c)(3) of the Internal Revenue Code, corporation, Massachusetts or similar business trust, limited liability company or partnership, not formed for the specific purpose of acquiring the securities offered, with total assets in excess of $5,000,000.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_5',
      },
      {
        id: iqID.id_investor_representations_6,
        showHelp: false,
        helpText: '',
        displayName:
          'A trust, with total assets in excess of $5,000,000, not formed for the specific purpose of acquiring the securities offered, whose purchase is directed by a sophisticated person as described in Rule 506(b)(2)(ii).',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_6',
      },
      {
        id: iqID.id_investor_representations_7,
        showHelp: false,
        helpText: '',
        displayName:
          'An employee benefit plan or retirement plan in which all of the participants are accredited investors.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_7',
      },
      {
        id: iqID.id_investor_representations_8,
        showHelp: true,
        helpText:
          'The term “revocable grantor trust” means a trust that is a “grantor trust” for U.S. federal income tax purposes, with the grantor or grantors (a) being the sole funding source of the trust, (b) serving as a trustee, or co-trustee, of the trust, (c) having sole investment discretion on behalf of the trust at the time the investment in the Fund is made and (d) having the right to amend or revoke the trust during the life of the grantor.',
        displayName:
          'A revocable grantor trust of which each settlor (i.e., grantor) is a natural person who is an accredited investor.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_8',
      },
      {
        id: iqID.id_investor_representations_9,
        showHelp: false,
        helpText: '',
        displayName: 'An entity in which all of the equity owners are accredited investors.',
        isSelected: false,
        name: '',
        identifier: 'Inv_Rep_9',
      },
      {
        id: iqID.id_investor_representations_or,
        showHelp: false,
        helpText: '',
        displayName:
          'Or, the undersigned hereby represents and warrants that: The Undersigned Is NOT An Accredited Investor.',
        isSelected: false,
        name: '',
        identifier: 'acre-Or',
      },
    ],
    qualifiedPurchaserRepresentations: [
      {
        id: iqID.id_purchase_representations_1,
        showHelp: true,
        helpText:
          'The term “investments” is generally restricted to the following: (a) stock in publicly held corporations, (b) limited partnership interests in private investment partnerships such as venture capital, private equity or hedge funds, (c) interests in registered investment companies such as mutual funds or exchange-traded funds, (d) cash, commodity interests, and physical commodities held for investment purposes, (e) real estate held for investment purposes (excluding real estate used for personal purposes or as a place of business) and (f) stock in privately-held corporations provided that each such privately-held corporation has shareholder’s equity, determined in accordance with GAAP and as of the date of its most recent financial statements (within the preceding 16 months), in excess of $50 million.',
        displayName:
          'A natural person (including a natural person investing through an individual retirement account or a self-directed employee benefit plan ) who owns at least $5,000,000 in investments (as defined in Rule 2a51-1 under the 1940 Act).',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_1',
      },
      {
        id: iqID.id_purchase_representations_3,
        showHelp: true,
        helpText:
          'The term “company” means a corporation, a partnership, an association, a joint-stock company, a trust, a fund, or any organized group of persons whether incorporated or not; or any receiver, trustee in bankruptcy or similar official or any liquidating agent for any of the foregoing, in his or her capacity as such.',
        displayName:
          'A family owned company that (i) was not formed for the specific purpose of investing in the Fund, (ii) owns at least $5,000,000 in investments, and (iii) is owned directly or indirectly by or for two or more natural persons who are related as siblings or spouses (including former spouses), or direct lineal descendants by birth or adoption, spouses of such persons, the estates of such persons, or foundations, charitable organizations, or trusts established by or for the benefit of such persons.',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_3',
      },
      {
        id: iqID.id_purchase_representations_4,
        showHelp: false,
        helpText: '',
        displayName:
          'A trust that was not formed for the specific purpose of investing in the Fund, and the trustee or other person authorized to make decisions with respect to the trust and each settlor or other person who has contributed assets to the trust, is a qualified purchaser described in clauses (i), (ii), or (iv) of Section 2(a)(51) of the 1940 Act.',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_4',
      },
      {
        id: iqID.id_purchase_representations_2,
        showHelp: false,
        helpText: '',
        displayName:
          'A natural person or a company that was not formed for the specific purpose of investing in the Fund, acting for its own account or the accounts of other qualified purchasers, and who in the aggregate owns and invests on a discretionary basis, at least $25,000,000 in investments (as defined in Rule 2a51-1 under the 1940 Act).',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_2',
      },
      {
        id: iqID.id_purchase_representations_5,
        showHelp: false,
        helpText: '',
        displayName:
          'A qualified institutional buyer as defined in Rule 144A under the Securities Act (not formed for the specific purpose of investing in the Fund), acting for its own account, the account of another qualified institutional buyer, or the account of a qualified purchaser, provided that the undersigned is not (1) a dealer described in Rule 144A(a)(1)(ii), that owns and invests on a discretionary basis less than $25,000,000 in securities of issuers that are not affiliated persons of the dealer, or (2) a plan referred to in Rule 144A(a)(1)(i)(D) or (E), or a trust fund referred to in Rule 144A(a)(1)(i)(F) that holds the assets of such a plan, the investment decisions with respect to which are made by the beneficiaries of the plan, unless the investment decision to invest in the Fund is made solely by the fiduciary, trustee, or sponsor of such plan.',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_5',
      },
      {
        id: iqID.id_purchase_representations_6,
        showHelp: false,
        helpText: '',
        displayName:
          'The undersigned is a company all of whose outstanding securities are beneficially owned by qualified purchasers.',
        isSelected: false,
        name: '',
        identifier: 'Pur_Rep_6',
      },
      {
        id: iqID.id_purchase_representations_or,
        showHelp: false,
        helpText: '',
        displayName:
          'Or, the undersigned hereby represents and warrants that: The Undersigned Is NOT A Qualified Purchaser.',
        isSelected: false,
        name: '',
        identifier: 'pur-or',
      },
    ],
    qualifiedClientRepresentations: [
      {
        id: iqID.id_client_representations_1,
        showHelp: false,
        helpText: '',
        displayName:
          'A natural person or company that will make a capital commitment to the Fund of at least $1,000,000.',
        isSelected: false,
        name: '',
        identifier: 'Cli_Rep_1',
      },
      {
        id: iqID.id_client_representations_2,
        showHelp: true,
        helpText:
          'For purposes of calculating the net worth of a natural person, the amount of any mortgage or other indebtedness secured by such person’s primary residence must be netted against the value of such residence. If the amount of such indebtedness is less than the estimated fair market value of such residence, it need not be considered as a liability deducted from such natural person’s net worth (except that if the amount of indebtedness outstanding at the time of calculation exceeds the amount outstanding 60 days before such time, other than as a result of the acquisition of the primary residence, the amount of such excess must be included as a liability). If the amount of such indebtedness exceeds the estimated fair market value of such residence, then that excess liability must be deducted from such natural person’s net worth.',
        displayName:
          'A natural person or company that has a net worth (together, in the case of a natural person, with assets jointly held with a spouse) of more than $2,100,000 (excluding the value of the primary residence of such natural person).',
        isSelected: false,
        name: '',
        identifier: 'Cli_Rep_2',
      },
      {
        id: iqID.id_client_representations_or,
        showHelp: false,
        helpText: '',
        displayName:
          'Or, the undersigned hereby represents and warrants that: The Undersigned Is NOT A Qualified Client.',
        isSelected: false,
        name: '',
        identifier: 'cli-or',
      },
    ],
    foreignPersonStatusRepresentations: [
      {
        id: iqID.id_foreign_person_1,
        showHelp: false,
        helpText: '',
        displayName:
          'A foreign national (i.e., an individual that is a citizen of a foreign (i.e., non-U.S.) country, even if such person is also a U.S. citizen or green card holder, or an individual who does not owe his or her sole allegiance to the United States).',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_1',
      },
      {
        id: iqID.id_foreign_person_2,
        showHelp: false,
        helpText: '',
        displayName:
          'A foreign government (i.e., any non-U.S. government or body exercising governmental functions), including any  national and subnational governments and their respective departments, agencies, and instrumentalities.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_2',
      },
      {
        id: iqID.id_foreign_person_3,
        showHelp: false,
        helpText: '',
        displayName:
          'A foreign entity, including any branch, partnership, group or sub-group, association, estate, trust, corporation, or division of a corporation, or organization organized or incorporated under the laws of a foreign (i.e., non-U.S.) jurisdiction, if either (a) its principal place of business is outside the United States or (b) its equity securities are primarily traded on one or more foreign exchanges, unless a majority of the equity interest in such entity is ultimately owned by U.S. nationals. For purposes of this question, “principal place of business” means the primary location where an entity’s management directs, controls, or coordinates the entity’s activities, or, in the case of an investment fund, where the  fund’s activities and investments are primarily directed, controlled, or coordinated by or on behalf of the general partner, managing member, or equivalent.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_3',
      },
      {
        id: iqID.id_foreign_person_4,
        showHelp: false,
        helpText: '',
        displayName:
          'An entity over which a foreign person exercises or could exercise control (including a trust, corporation, partnership, limited liability company, or equivalent legal entity organized or incorporated under the laws of any state of the United States over which control is exercised or may be exercisable, in any form, by a foreign national, foreign government or foreign entity (e.g., has a foreign manager or general partner; a  foreign person otherwise participates in important decision-making processes; etc.)). For purposes of this question, “control” means the power, direct or indirect, whether exercised or not exercised, to determine, direct, or decide important matters affecting an entity, and includes negative control (i.e., the ability to prevent an entity from making a particular decision).',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_4',
      },
      {
        id: iqID.id_foreign_person_or,
        showHelp: false,
        helpText: '',
        displayName:
          'Not a foreign person under any of the previous definitions included in this Section F or otherwise as defined under Section 721 of the Defense Production Act of 1950, as amended, including all implementing regulations thereof.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat-or',
      },
    ],
    foreignPersonStatusRepresentations2: [
      {
        id: iqID.id_foreign_person_2_1,
        showHelp: false,
        helpText: '',
        displayName:
          'The  undersigned is  not  an  investment fund  and  no  national or subnational governments of  a  single foreign (i.e.,  non-U.S.)  state holds a voting interest, direct or indirect, of 49 percent or more in the undersigned.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_2_1',
      },
      {
        id: iqID.id_foreign_person_2_2,
        showHelp: false,
        helpText: '',
        displayName:
          'The  undersigned is  an  investment fund  and  no  national or subnational governments of  a  single foreign (i.e.,  non-U.S.)  state holds  49  percent or  more  of  the  interest in  the  general partner, managing member, or equivalent of the undersigned.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_2_2',
      },
      {
        id: iqID.id_foreign_person_2_or,
        showHelp: false,
        helpText: 'Or, the undersigned hereby represents and warrants that:',
        displayName:
          'The undersigned is an entity and is unable to make either of the representations above.',
        isSelected: false,
        name: '',
        identifier: 'For_Per_Stat_2-or',
      },
    ],
    wiringBankStatus: [
      {
        id: iqID.id_wiring_bank_status_1,
        tooltip:
          'As of the date this form of Investor Questionnaire was prepared, the countries, territories and organizations (each, a “FATF Country”) that make up the membership of the Financial Action Task Force are: Argentina, Australia, Austria, Belgium, Brazil, Canada, China, Denmark, European Commission, Finland, France, Germany, Greece, Gulf Co-operation Council, Hong Kong (China), Iceland, India, Ireland, Israel, Italy, Japan, Kingdom of the Netherlands, Luxembourg, Malaysia, Mexico, New Zealand, Norway, Portugal, Republic of Korea, Saudi Arabia, Singapore, South Africa, Spain, Sweden, Switzerland, Turkey, United Kingdom, and United States. While the Russian Federation was formerly a FATF Country, its membership was suspended on February 24, 2023. (Source: www.fatf-gafi.org.)',
         radioIdentifier: parseRadioIds(iqID.id_wiring_bank_status_1),
          name: 'J_1_quest',
        displayName:
          '1. Is the bank or other financial institution from which the undersigned’s funds will be wired (the “Wiring Bank”) located in the United States or another “FATF Country”?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_wiring_bank_status_1_opt,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'J_1_if_quest',
        displayName: 'In what non-”FATF Country” is the Wiring Bank located? (See tooltip above for a current list of “FATF Countries.”)',

        size: 'large',
        type: 'opt',
        conditional: false,
      },
      {
        id: iqID.id_wiring_bank_status_2,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_wiring_bank_status_2),
        name: 'J_2_quest',
        displayName: '2. Is the undersigned a customer of the Wiring Bank?',

        size: 'large',
        type: 'quest',
      },
    ],
    identificationofSpecialEntities: [
      {
        id: iqID.id_special_entities_1,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_1_quest',
        displayName: '1. ERISA Partner',

        size: 'large',
        type: 'title',
      },
      {
        id: iqID.id_special_entities_1_a,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_1_a),
        name: 'F_1_a_quest',
        displayName:
          '(a). Is the undersigned \n(a) an employee benefit plan subject to Part 4 of Subtitle B of Title I of the Employee Retirement Income Security Act of 1974, as amended (“ERISA”) or \n(b) a plan described in Section 4975(e)(1) of the Internal Revenue Code?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_1_b,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_1_b),
        name: 'F_1_b_quest',
        displayName:
          '(b). Is the undersigned (a) an entity whose underlying assets are considered “plan assets” of an employee benefit plan that is subject to Part 4 of Subtitle B of Title I of ERISA and that invested in such entity or (b) an entity whose underlying assets are considered “plan assets” of a plan that is described in Section 4975(e)(1) of the Internal Revenue Code and that invested in such entity?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_1_b_opt,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_1_b_if_quest',
        displayName:
          'If "YES", what percentage of the undersigned’s underlying assets is considered “plan assets”?',

        size: 'col-lg-5 col-md-5 col-sm-5 col-xs-5 tab-space',
        type: 'opt',
        conditional: true,
      },
      {
        id: iqID.id_special_entities_2,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_2_quest',
        displayName: '2. Potential Lookthrough Entity',

        size: 'large',
        type: 'title',
      },
      {
        id: iqID.id_special_entities_2_a,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_2_a),
        name: 'F_2_a_quest',
        displayName:
          '(a). Is the undersigned, or would the undersigned be but for the exception provided in either Section 3(c)(1) or Section 3(c)(7) of the 1940 Act, an “investment company,” as defined in the 1940 Act?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_2_b,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_2_b),
        name: 'F_2_b_quest',
        displayName:
          '(b). Was the undersigned formed for the specific purpose of investing  in the Fund?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_2_c,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_2_c),
        name: 'F_2_c_quest',
        displayName:
          '(c). Are the shareholders, partners or other holders of equity or beneficial interests of the undersigned able to decide individually whether to participate or not participate in, or share in the profits and losses of, the undersigned’s investment in the Fund?',
        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_2_d,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_2_d),
        name: 'F_2_d_quest',
        displayName:
          '(d). Does the amount of the undersigned’s capital commitment in the Fund exceed 40% of the undersigned’s total assets?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_2_e_opt,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_2_e_quest',
        displayName:
          '(e). If the answer to any of 2(a)-(d) above is “YES,” how many beneficial owners does the undersigned have for purposes of Section 3(c)(1) of the 1940 Act?',

        size: 'col-lg-5 col-md-5 col-sm-5 col-xs-5 tab-space',
        type: 'opt',
        conditional: false,
      },
      {
        id: iqID.id_special_entities_3,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_3_quest',
        displayName:
          '3. Government Entity: Is the undersigned a state or political subdivision of a state, including',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'title',
      },
      {
        id: iqID.id_special_entities_3_a,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_3_a),
        name: 'F_3_a_quest',
        displayName: '',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_4,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_4),
        name: 'F_4_quest',
        displayName:
          '4. Bank Holding Company Partner: Is the undersigned a bank holding company or a company otherwise subject to the Bank Holding Company Act of 1956, as amended, or a subsidiary of such bank holding company?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_5,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_5),
        name: 'F_5_quest',
        displayName:
          '5. Private Foundation Partner: Is the undersigned a “private foundation” as described in Section 509 of the Internal Revenue Code?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_6,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_6),
        name: 'F_6_quest',
        displayName:
          '6. Public Pension Partner: Is the undersigned (a) a pension fund or retirement system for a government entity, or (b) a partnership of which one or more partners is a pension fund or retirement system for a government entity?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_7,
        tooltip:
          'The U.S. Securities and Exchange Commission has not defined a “fund-of-funds,” but has indicated that the term can be interpreted in a reasonable manner in accordance with industry parlance, and has suggested that a pooled investment vehicle that invests 10% or more of its capital in other pooled investment vehicles is a “fund-of-funds.”',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_7),
        name: 'F_7_quest',
        displayName: '7. Fund-of-Funds: Is the undersigned a “fund-of-funds”?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_8,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_8),
        name: 'F_8_quest',
        displayName:
          '8. United States Tax-Exempt Partner: Is the undersigned exempt from the payment of United States federal income tax (i.e., has the undersigned applied for and received special tax exempt status from the United States Internal Revenue Service)?',

        size: 'large',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_9,
        tooltip: '',
        radioIdentifier: ['', ''],
        name: 'F_9_quest',
        displayName: '9. Flow-Through Entity:',

        size: 'large',
        type: 'title',
      },
      {
        id: iqID.id_special_entities_9_a,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_9_a),
        name: 'F_9_a_quest',
        displayName:
          '(a). Is the undersigned classified as a partnership for U.S. federal income tax purposes?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_9_b,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_9_b),
        name: 'F_9_b_quest',
        displayName:
          '(b). If the answer to 9(a) above is “YES,” is every beneficial owner of the undersigned a “United States person,” as defined in section 7701(a)(30) of the Internal Revenue Code? (For clarity, a “Yes” answer indicates that every underlying owner of the undersigned is a “United States person.”)',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
      {
        id: iqID.id_special_entities_9_c,
        tooltip: '',
        radioIdentifier: parseRadioIds(iqID.id_special_entities_9_c),
        name: 'F_9_c_quest',
        displayName:
          '(c). If the answer to 9(a) above is “YES,” is any beneficial owner of the undersigned exempt from the payment of United States federal income tax (i.e., because such beneficial owner has applied for and received special tax exempt status from the United States Internal Revenue Service)?',

        size: 'col-lg-10 col-md-10 col-sm-10 col-xs-10 tab-space',
        type: 'quest',
      },
    ],
    warrantiesExceptions: [
      {
        id: iqID.id_warranties_exceptions,
        tooltip: '',
        description:
          'The undersigned should specify below any applicable exceptions to any of the representations and warranties contained in this Investor Questionnaire or in the Fund Agreement. The undersigned hereby makes the following exceptions to such representations and warranties:',
        radioIdentifier: ['', ''],
        name: 'W_1_quest',
        displayName: 'Warranties Exceptions',

        size: 'large',
        type: 'quest',
      },
    ],
  },
};
